module.exports = __webpack_public_path__ + "img/cote-pc-0218-03.131ef85f.png";